// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2651":"78479dabe0d2067d","5045":"c1a2dab3aa79b802","7595":"64c1184af0fcf473"}[chunkId] + ".css";
};